import { objectFromEntries } from '../utils/types-utils';

const scrollVerticalAlignmentKeys = [
    'start',
    'center',
    'end',
    'nearest'
];

const scrollVerticalAlignment =
    objectFromEntries(
        scrollVerticalAlignmentKeys
            .map(key => [key.toUpperCase(), key])
    );

export {
    scrollVerticalAlignment
}